/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findEmployeeRoles} from '../api'

export const useMutationFindEmployeeRoles = createReactQueryMutationHook('findEmployeeRoles', findEmployeeRoles)
